import { useEffect, useRef, useState, KeyboardEvent } from "react";
import Logo from "../../assets/logo.svg";
import Menu from "../../assets/icons/menu.svg?react";
import Close from "../../assets/icons/x-mark.svg?react";
import Location from "../../assets/icons/location.svg?react";
import { Button } from "../ui/Button";
import { NavigationBar, NavItem } from "./NavigationBar";
import { HeaderCarousel } from "./HeaderCarousel";
import { AnimatePresence, motion } from "motion/react";
import { Select } from "../ui/Select";
import { Link } from "react-router";
import { useStation } from "../../contexts/StationContext";
import { useAuth } from "../../contexts/AuthContext";
import { Station } from "../../types/station";
import { useGlobal } from "../../contexts/GlobalContext";
import { useParams, useNavigate, useLocation } from "react-router";
import { NavigationBarBottom } from "./NavigationBarBottom";
import Whatsapp from "../../assets/icons/social-icons/whatsapp.svg?react";
import { getIdFromUrlName, generateUrl } from "../../utils/urlUtils";
export const Header: React.FC = () => { 
  const dropdownRef = useRef<HTMLUListElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();

  const [active, setActive] = useState<string>('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { stationUrlName } = useParams();
  const stationId = getIdFromUrlName(stationUrlName || '');
  const { station, stations, fetchStation, fetchMyNearestStation, setMyStation } = useStation();
  const location = useLocation();
  useEffect(() => {
    if (stationId === "0") {
      const paths = location.pathname.split('/')
      const path = paths.slice(2).join('/');
      fetchMyNearestStation().then(station => {
        navigate(generateUrl(station?.name || '', station.id || '') + `/${path}`);
        setMyStation(station);

      }).catch(error => {
        console.error('Error fetching nearest station:', error);
      });
    } 
    else if (+(stationId || '') > 0) {
      try {
        if(stationId)  fetchStation(stationId);
      } catch (error) {  
        console.log("Error fetching station:", error);
        navigate("/0/404");
      }
    }else{{
      navigate("/0/404");
    }}
  }, []);
  const onClickNavItem = (item: NavItem) => {
    setActive(active === 'RJs' ? '' : item.label);
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  }

  const { user, isAuthenticated, logout, setIsAuthOpen, setCurrentScreen } = useAuth();
  const { getSocialMediaDetails } = useGlobal();

  const selectStation = (selected: Station) => {
    fetchStation(selected.id);
    setIsMenuOpen(false);
    const path = location.pathname
    const paths = path.split('/').slice(2);
    let menupath = paths[0]
    if(menupath==="rjs") menupath='home'
    navigate(generateUrl(selected.name || '', selected.id || '') + `/${menupath}`);
  }

  const getInitials = (name: string) => {
    return name.split(' ').map(word => word[0]).join('');
  }

  const onClickDropdown = (option?: string) => {
    setIsDropdownOpen(!isDropdownOpen);
    if (option) {
      if (option === 'Log Out') {
        logout();
        setCurrentScreen('signIn');
      } else if (option === 'Change Password') {
        setIsAuthOpen(true);
        setCurrentScreen('changePassword');
      }
    }
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLUListElement>) => {
    const items = dropdownRef.current?.querySelectorAll<HTMLButtonElement>("button");
    if (!items || !isDropdownOpen) return;

    const currentIndex = Array.from(items).indexOf(document.activeElement as HTMLButtonElement);

    if (e.key === "ArrowDown") {
      e.preventDefault();
      items[(currentIndex + 1) % items.length]?.focus();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      items[(currentIndex - 1 + items.length) % items.length]?.focus();
    } else if (e.key === "Escape") {
      setIsDropdownOpen(false);
      buttonRef.current?.focus();
    }
  }

  const onBackdropClick = (e: MouseEvent) => {
    if (dropdownRef.current?.contains(e.target as Node) || buttonRef.current?.contains(e.target as Node)) return;
    setIsDropdownOpen(false);
  }

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener("mousedown", onBackdropClick);
    } else {
      document.removeEventListener("mousedown", onBackdropClick);
    }

    return () => {
      document.removeEventListener("mousedown", onBackdropClick);
    };
  }, [isDropdownOpen]);

  useEffect(() => {
    if (isDropdownOpen) {
      const items = dropdownRef.current?.querySelectorAll<HTMLButtonElement>("button");
      if (items && items[0]) items[0]?.focus();
    }
  }, [isDropdownOpen]);

  return (
    <>
      <header className="sticky top-0 z-50 bg-black">
        <nav className="flex justify-between items-center px-4 py-3 text-white md:px-6 md:py-3">
          {/* Mobile Menu Button */}
          <span className="md:hidden">
            <button type="button" className={`transition-all ${isMenuOpen ? 'rotate-90' : 'rotate-0s'}`} onClick={toggleMenu}>
              {isMenuOpen ? <Close /> : <Menu />}
            </button>
          </span>
          {/* Logo */}
          <button type="button" onClick={() => navigate(generateUrl(station?.name || '', station.id || '') + '/home')}>
            <img src={station?.logo || Logo} srcSet={`${station?.logo || Logo} 1x, ${station?.logo || Logo} 2x`} loading="lazy" alt={station?.logoAlt || station?.name+"'s logo"} className="w-[92px] h-[80px] md:w-[104px] md:h-[88px]" />
          </button>
          <section className="flex items-center gap-6">
            {/* Desktop Navigation and Social Media Links */}
            <div className="hidden md:flex items-center gap-6">
              <NavigationBar    station={station} onClickNavItem={onClickNavItem} />
              <ul className="hidden lg:flex gap-2">
                {
                  station?.socialMediaLink?.map((socialMedia, index) => {
                  const social = getSocialMediaDetails(socialMedia?.platformId, 'text-black size-6',true)
                    return (<li key={index} className="flex" title={social?.name}>
                      <Link to={socialMedia.url} target="_blank" rel="noopener noreferrer" className="rounded-full">
                       {social?.icon}
                      </Link>
                    </li>)
                })
                }
                {station?.whatsappChannelUrl && (
                  <li key='whatsapp-channel-link-header' title="Whatsapp">
                    <Link to={station?.whatsappChannelUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 rounded-full">
                      <Whatsapp className="size-6 text-green-500" />
                    </Link>
                  </li>
                )}
              </ul>
              <div className="hidden lg:flex">
                <Select
                  value="id"
                  state="name"
                  options={stations}
                  selectedOption={station?.name}
                  onSelect={selectStation}
                  variant="plain"
                  width='w-auto min-w-[200px]'
                  borderColor='border-none'
                  leadingIcon={<Location className="text-white" />}
                />
              </div>
            </div>
            {/* User Authentication Button or User Info */}
            {!isAuthenticated ?
              <Button variant="primary" onClick={() => setIsAuthOpen(true)}>Log In</Button> :
              <div className="relative flex items-center gap-2">
                <div className="flex flex-col justify-between gap-1">
                  <span className="text-sm text-white font-medium leading-none">{user?.name}</span>
                  <span className="text-sm text-white font-medium leading-none">{user?.email}</span>
                </div>
                <button type="button" ref={buttonRef} className="flex items-center justify-center bg-gradient-to-b from-[#C71C22] to-[#610E10] w-9 h-9 rounded-full text-white font-medium" onClick={() => onClickDropdown()}>{getInitials(user?.name || '')}</button>
                <AnimatePresence>
                  {isDropdownOpen &&
                    <motion.ul ref={dropdownRef} role="menu" className="absolute top-12 right-0 w-max flex flex-col p-1 bg-black border border-[#3F3F46] rounded-md shadow-md" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.25, ease: 'easeInOut' }} onKeyDown={handleKeyDown}>
                      {['Change Password', 'Log Out'].map((item, index) => (
                        <li key={index} role="menuitem" className="text-sm text-white">
                          <motion.button type="button" className="focus:bg-primary-700 outline-none rounded-sm px-4 py-2 text-sm text-white w-full text-left" onClick={() => onClickDropdown(item)}>{item}</motion.button>
                        </li>
                      ))}
                    </motion.ul>
                  }
                </AnimatePresence>
              </div>
            }
          </section>
        </nav>

        {/* Header Carousel for Desktop View */}
        <AnimatePresence>
          {
            active === 'RJs' && (
              <motion.div className="hidden md:block bg-black absolute top-full left-0 w-full" key="rjs" initial={{ y: -10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -10, opacity: 0 }} transition={{ duration: 0.25 }}>
                <HeaderCarousel onClickProfile={() => setActive('')} />
              </motion.div>
            )
          }
        </AnimatePresence>
        {/* Mobile Menu for Mobile View */}
        <AnimatePresence>
          {
            isMenuOpen && (
              <motion.div className="md:hidden" initial={{ height: 0, opacity: 0 }} key="menu" animate={{ height: '100vh', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.25 }}>
                <NavigationBar
                  stations={stations}
                  station={station}
                  onClickNavItem={(navItem) => { onClickNavItem(navItem); setIsMenuOpen(navItem.label === 'RJs' || navItem.label==='Talent Hunt'); }}
                  onClickRJ={() => setIsMenuOpen(false)}
                  onSelectStation={selectStation}
                />
              </motion.div>
            )
          }
        </AnimatePresence>
      </header>
      {/* // footer for mobile view only  */}
      <footer className="md:hidden fixed bottom-0 z-[200] bg-gray-200 w-full">
        <NavigationBarBottom onClickNavItem={onClickNavItem} />
      </footer>
    </>
  );
};